// extracted by mini-css-extract-plugin
export var clickThrough = "_y9-2";
export var fallback = "_y9-5";
export var frame = "_y9-3";
export var frameCell = "_y9-1";
export var overlay = "_y9-4";
export var wrapper = "_y9-0";